export default __webpack_public_path__ + "static/media/Daddy.b8ddb8f2.png";